import { render, staticRenderFns } from "./skuItem.vue?vue&type=template&id=f39f876c&"
import script from "./skuItem.vue?vue&type=script&lang=js&"
export * from "./skuItem.vue?vue&type=script&lang=js&"
import style0 from "./skuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports